import { render, staticRenderFns } from "./productApproval.vue?vue&type=template&id=5d30e138&scoped=true&"
import script from "./productApproval.vue?vue&type=script&lang=js&"
export * from "./productApproval.vue?vue&type=script&lang=js&"
import style0 from "./productApproval.vue?vue&type=style&index=0&id=5d30e138&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d30e138",
  null
  
)

export default component.exports